import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllQuestions() {
  try {
    const response = await fetch(base + 'questions');
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllQuestions', error);
    throw error;
  }
}

export async function getQuestion(id) {
  try {
    const response = await fetch(base + 'questions/' + id);
    return await response.json();
  } catch (error) {
    console.error('Erreur getQuestion', error);
    throw error;
  }
}
  
export async function getAllQuestionsByParcours(p) {
  try {
    const response = await fetch(base + 'questions/p/' + p);
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllQuestionsByVillage', error);
    throw error;
  }
}
    
export async function createQuestion(parcoursId, libelle, questionImage, type, indiceTexte, indiceImage) {

  console.log("libelle = ", libelle);
  console.log("questionImage = ", questionImage);
  console.log("type = ", type);
  console.log("indiceTexte = ", indiceTexte);
  console.log("indiceImage = ", indiceImage);

  try {
    const authToken = localStorage.getItem("authToken");

    // Création de l'objet FormData pour envoyer des fichiers
    const formData = new FormData();
    formData.append('libelle', libelle);
    formData.append('id_parcours', parcoursId);
    formData.append('type', type);
    
    // Logique "soit texte, soit image" ==> A réévaluer !!!
    if (indiceTexte && !indiceImage) {
      formData.append('indice', indiceTexte);
    } else if (!indiceTexte && indiceImage) {
      formData.append('img_helper', indiceImage);
    } else if (indiceTexte && indiceImage) {
      throw new Error("Veuillez fournir soit un indice texte, soit une image, mais pas les deux.");
    }
    
    if (questionImage) {
      formData.append('image', questionImage);
    }

    const response = await fetch(base + 'questions/insert', {
      method: 'POST',
      credentials: "include", 
      headers: { 'Authorization': `Bearer ${authToken}` },
      body: formData
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur createQuestion', error);
    throw error;
  }
}

export async function updateQuestion(id, libelle, questionImage, type, helperText, helperImage, delete_image, parcoursId = null, placement = null) {
  try {
    const authToken = localStorage.getItem("authToken");

    const formData = new FormData();
    formData.append('id', id);
    formData.append('libelle', libelle);
    formData.append('type', type);
    formData.append('type', type);

    if (parcoursId !== null) {
      formData.append('id_parcours', parcoursId);
    }

    if (placement !== null) {
      formData.append('placement', placement);
    }

    // Indices (texte et image peuvent coexister maintenant)
    if (helperText) {
      formData.append('helper', helperText);
    }
    // if (helperImage) {
    //   formData.append('img_helper', helperImage);
    // }

    // if (questionImage) {
    //   formData.append('image', questionImage);
    // }
    if (helperImage instanceof File) {
      formData.append('img_helper', helperImage);
    }

    if (questionImage instanceof File) {
      formData.append('image', questionImage);
    } else if (delete_image === true) {
      formData.append('delete_image', 'true'); // 👈 flag de suppression
    }

    const response = await fetch(base + 'questions/update', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
      body: formData,
    });

    return await response.json();
  } catch (error) {
    console.error('Erreur updateQuestion', error);
    throw error;
  }
}
    
export async function deleteQuestion(questionId) { 
    try {
        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + 'questions/delete', {
        method: 'POST',
        credentials: "include", 
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}` 
        },
        body: new URLSearchParams({id: questionId }),
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur deleteQuestion', error);
        throw error;
    }
}